const lotteryArr = [{
        path: "/myLotterySignUp",
        name: "myLotterySignUp",
        component: () =>
            import ("@/views/lotteryApp/myLotterySignUp.vue"),
        meta: {
            title: "我要报名",
            isLogin: true
        }
    }, {
        path: "/signUpRecord",
        name: "signUpRecord",
        component: () =>
            import ("@/views/lotteryApp/signUpRecord.vue"),
        meta: {
            title: "我的报名记录",
            isLogin: true
        }
    },
    {
        path: "/ItemList",
        name: "ItemList",
        component: () =>
            import ("@/views/lotteryApp/ItemList.vue"),
        meta: {
            title: "项目列表"
        }
    },
    {
        path: "/entrance",
        name: "entrance",
        component: () =>
            import ("@/views/lotteryApp/entrance.vue"),
        meta: {
            title: "入口"
        }
    },
    {
        path: "/preview",
        name: "preview",
        component: () =>
            import ("@/views/lotteryApp/preview.vue"),
        meta: {
            title: "购房承诺书"
        }
    },
    {
        path: "/marryPreview",
        name: "marryPreview",
        component: () =>
            import ("@/views/lotteryApp/marryPreview.vue"),
        meta: {
            title: "婚姻声明书"
        }
    }




];
export default lotteryArr;